import { httpCreate } from './http';

const http = httpCreate('/srv/material-system');

export const materialSystem = {
	getList(params) {
		return http.get('/list', { params });
	},
	use(id, data) {
		return http.post(`/use/${id}?photoLive=0`, data);
	},
};
